<template>
  <div class="area">
    <h2 class="mb-4">Áreas</h2>
    <div class="card-container">
      <div class="card">
        <div class="text">
          <div class="bg bg4"></div>
          <p class="card-title">Marcas</p>
          <p>Advogados e estagiários de Direito</p>
        </div>
        <button
          @click="
            $router.push({
              name: 'jobs.group',
              params: { group: 'marcas' }
            })
          "
          @blur="close()"
          class="know-more"
        >
          SAIBA MAIS
        </button>
      </div>
      <div class="card">
        <div class="text">
          <div class="bg bg5"></div>
          <p class="card-title">Contencioso</p>
          <p>Advogados e estagiários de Direito</p>
        </div>
        <button
          @click="
            $router.push({
              name: 'jobs.group',
              params: { group: 'contecioso' }
            })
          "
          @blur="close()"
          class="know-more"
        >
          SAIBA MAIS
        </button>
      </div>
      <div class="card">
        <div class="text">
          <div class="bg bg1"></div>
          <p class="card-title">Consultoria e Contratos</p>
          <p>Advogados e estagiários de Direito</p>
        </div>
        <button
          @click="
            $router.push({
              name: 'jobs.group',
              params: { group: 'consultoria-e-contratos' }
            })
          "
          @blur="close()"
          class="know-more"
        >
          SAIBA MAIS
        </button>
      </div>
      <div class="card">
        <div class="text">
          <div class="bg bg6"></div>
          <p class="card-title">Digital</p>
          <p>Advogados e estagiários de Direito</p>
        </div>
        <button
          @click="
            $router.push({
              name: 'jobs.group',
              params: { group: 'digital' }
            })
          "
          @blur="close()"
          class="know-more"
        >
          SAIBA MAIS
        </button>
      </div>
      <div class="card">
        <div class="text">
          <div class="bg bg2"></div>
          <p class="card-title">Patentes</p>
          <p>
            Engenheiros, Biólogos, Farmacêuticos, Químicos, Biotecnologistas.
          </p>
        </div>
        <button
          @click="
            $router.push({
              name: 'jobs.group',
              params: { group: 'patentes' }
            })
          "
          @blur="close()"
          class="know-more"
        >
          SAIBA MAIS
        </button>
      </div>
      <div class="card">
        <div class="text">
          <div class="bg bg3"></div>
          <p class="card-title">Apoio Administrativo</p>
          <p>
            Profissionais de Finanças, Faturamento, Bibliotecários, Copa,
            Infraestrutura, Marketing, Paralegais, Recursos Humanos,
            Recepcionistas, Secretárias e Tecnologia da Informação
          </p>
        </div>
        <button
          @click="
            $router.push({
              name: 'jobs.group',
              params: { group: 'apoio-administrativo' }
            })
          "
          @blur="close()"
          class="know-more"
        >
          SAIBA MAIS
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang="scss">
.area {
  margin-top: -50px;
  text-align: center;
  h2 {
    color: theme-color(primary);
  }

  .card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1400px;
    margin: auto;
    .card {
      overflow: hidden;
      background-color: #fff;
      height: auto;
      box-shadow: 0px 0px 10px rgb(184, 184, 184);
      margin: 10px 30px;
      max-width: 300px;

      button {
        transition: all 0s ease-in-out !important;
      }
      .know-more {
        background-color: #fff;
        border: transparent;
        color: #121212;
        font-size: 1rem;
        padding: 0.7rem 2.5rem;
        border-radius: 2px;
        transition: all 0.2s ease-in-out;
        margin-bottom: 2.4rem;
        border: 1px solid #46797B;
        border-radius: 8px;
        color: #46797B;
        margin-top: 2rem;
        width: 70%;
        &:hover {
          background-color: #46797B;
          color: #fff;
        }
        &.mini {
          width: 110px;
          cursor: pointer;

          &:hover {
            background-color: transparent;
            color: #fff;
          }
        }
      }
      p {
        font-size: 1.2rem;
        line-height: calc(1.2rem * 1.7);
        padding: 0px 1rem;
      }
      border-radius: 4px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      @include media-breakpoint-down(sm) {
      }
      &.disabled {
        filter: grayscale(100%);
        button {
          width: 0px;
          overflow: hidden;
          padding: 0px;
          border: none;
          transition: all 0s ease-in-out;
        }
      }

      .text {
        position: relative;
        z-index: 99;
        text-align: center;
        width: 100%;
        background-color: #fff;
        h3 {
          font-weight: 400;
          font-size: 2.5rem;
          text-align: center;
          line-height: calc(2.5rem * 1.1);
          margin: 1.7rem 0px 1.5rem 0px;
        }
        @include media-breakpoint-down(lg) {
          h3 {
            font-size: 2rem;
            line-height: calc(2rem * 1.2);
          }
          .know-more {
            font-size: 1.1rem;
            margin-top: 3rem;
          }
        }

        .bg {
          height: 190px;
          width: 100%;
          position: relative;
          &.bg1 {
            background: url("../../../assets/images/consultoria.png") no-repeat
              center center;
            background-size: cover;
          }
          &.bg2 {
            background: url("../../../assets/images/patentes.png") no-repeat
              center center;
            background-size: cover;
          }
          &.bg3 {
            background: url("../../../assets/images/administrativo.png")
              no-repeat center center;
            background-size: cover;
          }
          &.bg4 {
            background: url("../../../assets/images/marcas.png") no-repeat
              center center;
            background-size: cover;
          }
          &.bg5 {
            background: url("../../../assets/images/contencioso.png") no-repeat
              center center;
            background-size: cover;
          }
          &.bg6 {
            background: url("../../../assets/images/digital.png") no-repeat
              center center;
            background-size: cover;
          }
        }
        .card-title {
          margin-top: 20px;
          font-size: 24px !important;
          color: black;
        }
      }
    }
  }
}
</style>
